import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOSection from './components/SEOSection';
import FeaturedScroll from './components/FeaturedScroll';
import CTASection from './components/CTASection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Superbuy Spreadsheet Hub',
    url: 'https://superbuyspread.cyou/',
    description: 'The ultimate independent resource center for Superbuy spreadsheet finds, product research guides, QC tips, and shopping education.',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://superbuyspread.cyou/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Superbuy Spreadsheet Hub',
    url: 'https://superbuyspread.cyou/',
    description: 'An independent resource center providing Superbuy spreadsheet guides, product finds, QC tips, and shopping education for smarter buying decisions.',
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
    foundingDate: '2026',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SEOSection />
        <FeaturedScroll />
        <CTASection />
        <ComparisonSection />
        <SafetySection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}